import { create } from 'zustand';

interface StoreTypeStore {
  selectedStoreTypes: string[];
  setSelectedStoreTypes: (storeTypes: string[]) => void;
  clearSelectedStoreTypes: () => void;
}

export const useStoreTypeStore = create<StoreTypeStore>(set => ({
  selectedStoreTypes: [],
  setSelectedStoreTypes: storeTypes => set({ selectedStoreTypes: storeTypes }),
  clearSelectedStoreTypes: () => set({ selectedStoreTypes: [] }),
}));
